import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "./BookAnAppointment.css";
import { Form, Row, CardGroup } from "react-bootstrap";
import axios from "axios";
import Card from "react-bootstrap/Card";
import background from "./assets/rela-logo.png";

const BookAnAppointment = () => {
  const [showdetails, setShowdetails] = useState(false);
  const [book, setBook] = useState(false);
  const doctorsArray = [];
  const [data, setData] = useState({
    department: [],
    selectedDept: "",
    listOfDoctors: [],
  });

  const handleShowConsultation = (event) => {
    event.preventDefault();
    setBook((prev) => !prev);
  };
  const handleClick = (event) => {
    event.preventDefault();
    setShowdetails(true);
  };

  useEffect(() => {
    const getDepartments = async () => {
      try {
        const response = await axios.get(
          "https://www.relainstitute.in/RELAAPI/api/HIS/Departments"
        );
        setData({ ...data, department: response.data });
      } catch (error) {
        console.log(error);
      }
    };

    getDepartments();
  }, []);

  useEffect(() => {
    handleGetDoctors();
  }, [data.selectedDept]);

  const handleGetDoctors = async () => {
    try {
      if (data.selectedDept) {
        const response = await axios.post(
          "https://www.relainstitute.in/RELAAPI/api/HIS/DepartmentWiseDoctorID",
          { DepID: data.selectedDept, DoctorID: "0" }
        );
        console.log(response.data);
        setData({ ...data, listOfDoctors: response.data });
        console.log(doctorsArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const maxDate = new Date().toISOString().slice(0, 10);
  const minimumDate = new Date(maxDate);
  const minDate = minimumDate.toISOString().slice(0, 10);
  return (
    <div style={{ textAlign: "center" }}>
      <Button
        className="appointment"
        style={{
          textAlign: "center",
          borderRadius: "5px",
          position: "relative",
          marginTop: "250px",
          padding: "10px",
        }}
        onClick={handleClick}
      >
        <img
          src="https://appointment.relainstitute.com/patient-portal/images/Book-an-appointment.png"
          alt="#"
        />
        <span>Book an Appointment</span>
      </Button>

      {showdetails && (
        <div style={{ paddingLeft: "50px", paddingRight: "50px" }}>
          <Form.Select
            style={{ width: "auto", margin: "auto", marginTop: "50px" }}
            value={data.selectedDept}
            onChange={(event) =>
              setData({ ...data, selectedDept: event.target.value })
            }
          >
            <option value="" disabled defaultValue>
              Select department
            </option>
            {data.department.length && (
              <>
                {data.department.map((department) => {
                  return (
                    <option
                      value={department.columnCode}
                      key={department.columnCode}
                    >
                      {department.columnName}
                    </option>
                  );
                })}
              </>
            )}
          </Form.Select>
        </div>
      )}

      {data.listOfDoctors && (
        <>
          {data.listOfDoctors.map((doctors) => {
            return (
              <>
                <div
                  style={{ padding: "5px", margin: "auto" }}
                  key={doctors.doctorname}
                >
                  <div className="container-1">
                    <div className="doctor-image">
                      <img src={doctors.photo_img} alt={doctors.doctorname} />
                    </div>

                    <div className="container-2">
                      <div>
                        <h2>{doctors.doctorname}</h2>
                      </div>
                      <div>
                        <h4>{doctors.qualification}</h4>
                      </div>
                      <div>
                        <Button href={doctors.profilelink}>View Profile</Button>
                      </div>
                      <div>
                        <Button onClick={handleShowConsultation}>
                          Hospital Consultation
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </>
      )}
    </div>
  );
};

export default BookAnAppointment;
